import React, { Fragment, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import TextField from '../../../../core/common/textFields/TextField';
import { useGetContactOpportunitiesByIdQuery, useGetOpportunityDetailsbyIdQuery, useGetProjectLookupsQuery } from '../../../../services/EndPointsApis';
import Select from "react-select";
import { customStyles } from '../../../../core/common/Custom Style/CustomStyle';

const OpportunityDetailsContactWizard = ({ formik, refetchOpportunityDetails, projectId, projectLookups }: any) => {

    const { data: opportunityByIdData, refetch } = useGetContactOpportunitiesByIdQuery({ id: '00000000-0000-0000-0000-000000000000' });

    const location = useLocation();
    const isReadOnly = location.pathname.includes('/projects/view-project');

    useEffect(() => {
        if (refetchOpportunityDetails === false && opportunityByIdData?.result && Object.keys(opportunityByIdData?.result).length > 0) {
            formik.setValues({ ...opportunityByIdData?.result });
        } else {
            // setUpdateId(0);
        }
    }, [opportunityByIdData, refetchOpportunityDetails]);

    return (
        <>
            <div className='row'>
                <h5 className='mb-3'>Opportunity Details</h5>
                <div className='col-md-5'>
                    <div className="d-flex mb-2">
                        <label className="input-label w-25">
                            Job Type{" "} <span className='text-danger'>*</span>
                        </label>
                        <Select
                            styles={customStyles}
                            className="select w-100"
                            options={projectLookups?.result?.Lst_JobType?.map((option: any) => ({
                                label: option?.value,
                                value: option?.id
                            }))}
                            value={
                                formik.values?.opportunityDetailsDescription?.jobType?.id
                                    ? {
                                        value: formik.values?.opportunityDetailsDescription?.jobType?.id,
                                        label: formik.values?.opportunityDetailsDescription?.jobType?.value,
                                    }
                                    : null
                            }
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('opportunityDetailsDescription.jobType.id', selectedOption.value);
                                formik.setFieldValue('opportunityDetailsDescription.jobType.value', selectedOption.label);

                            }}
                        />
                    </div>
                </div>
                <div className='col-md-7'>
                    <div className="form-wrap d-flex">
                        <label className='input-label w-25'>Description <span className='text-danger'>*</span></label>
                        <textarea
                            className='form-control'
                            rows={3}
                            type="text"
                            {...formik.getFieldProps("opportunityDetailsDescription.description")}
                        //   disabled={viewOnly}
                        />
                    </div>
                </div>
            </div>
            <div className='row'>
                <h5 className='mb-2 mt-2'>General Background</h5>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsSitution?.generalBackground?.slice(0, 4).map((background: any, index: any) => {
                                return (
                                    <Fragment key={index}>
                                        {background?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{background?.name}</p>
                                                <div className="d-flex gap-5 w-50 justify-content-end">
                                                    <label className="checkboxs positionCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={background.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsSitution.generalBackground[${index}].surveyResultOriginal`, background.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : background?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{background?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                style={{ width: 100 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsSitution.generalBackground[${index}].surveyResultOriginal`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsSitution.generalBackground[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                : background?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{background?.name}</p>
                                                        <div className="d-flex gap-3 w-50 justify-content-end">
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    style={{ width: 150 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsSitution.generalBackground[${index}].surveyResultOriginal`)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : background?.fieldType === "DD" ?
                                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                            <p className="mb-0 w-50">{background?.name}</p>
                                                            <Select
                                                                styles={customStyles}
                                                                className="select w-50"
                                                                options={projectLookups?.result?.
                                                                    Lst_HouseType?.map((option: any) => ({
                                                                        label: option?.value,
                                                                        value: option?.id
                                                                    }))}
                                                                value={
                                                                    formik.values.opportunityDetailsSitution.generalBackground[index]
                                                                        .surveyResultOriginal
                                                                        ? {
                                                                            label: formik.values.opportunityDetailsSitution.generalBackground[index].surveyResultOriginal,
                                                                            value: formik.values.opportunityDetailsSitution.generalBackground[index].surveyResultOriginal,
                                                                        }
                                                                        : null
                                                                }
                                                                // isDisabled={isReadOnly}
                                                                onChange={(selectedOption: any) => {
                                                                    formik.setFieldValue(`opportunityDetailsSitution.generalBackground[${index}].surveyResultOriginal`, selectedOption?.label);
                                                                    // formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                                                }}
                                                            />
                                                        </div>
                                                        : null
                                        }
                                    </Fragment>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik?.values?.opportunityDetailsSitution?.generalBackground?.slice(4, 8).map((background: any, index: any) => {
                                const actualIndex = index + 4;
                                return (
                                    <Fragment key={actualIndex}>
                                        {background?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{background?.name}</p>
                                                <div className="d-flex gap-5">
                                                    <label className="checkboxs positionCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={background.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsSitution.generalBackground[${actualIndex}].surveyResultOriginal`, background.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : background?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{background?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                style={{ width: 100 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsSitution.generalBackground[${actualIndex}].surveyResultOriginal`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsSitution.generalBackground[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                : background?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{background?.name}</p>
                                                        <div className="d-flex gap-2 w-50 justify-content-end">
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    style={{ width: 200 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsSitution.generalBackground[${actualIndex}].surveyResultOriginal`)}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    : background?.fieldType === "DD" ?
                                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                            <p className="mb-0 w-50">{background?.name}</p>
                                                            <Select
                                                                styles={customStyles}
                                                                className="select w-100"
                                                                options={projectLookups?.result?.
                                                                    Lst_HouseType?.map((option: any) => ({
                                                                        label: option?.value,
                                                                        value: option?.id
                                                                    }))}
                                                                value={
                                                                    formik.values?.lst_MethodOfInquiry?.id
                                                                        ? {
                                                                            value: formik.values?.lst_MethodOfInquiry?.id,
                                                                            label: formik.values?.lst_MethodOfInquiry?.value || '',
                                                                        }
                                                                        : null
                                                                }
                                                                // isDisabled={isReadOnly}
                                                                onChange={(selectedOption: any) => {
                                                                    formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                                                                    formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                                                }}
                                                            />
                                                        </div>
                                                        : null
                                        }
                                    </Fragment>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <h5 className='mb-2 mt-2'>Clients' Past Home Renovation Experience</h5>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsSitution?.clientpastHomeRenvExp?.slice(0, 4).map((clientPastHome: any, index: any) => (
                                <Fragment key={index}>
                                    {clientPastHome?.fieldType === "Option" ?
                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                            <p className="mb-0">{clientPastHome?.name}</p>
                                            <div className="d-flex gap-5">

                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={clientPastHome.surveyResultOriginal === '1'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsSitution.clientpastHomeRenvExp[${index}].surveyResultOriginal`, clientPastHome.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                            </div>
                                        </div>
                                        : clientPastHome?.fieldType === "Numeric" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0 w-50">{clientPastHome?.name}</p>
                                                <div className="d-flex gap-3 w-50 justify-content-end">

                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            className='w-100'
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsSitution.clientpastHomeRenvExp[${index}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsSitution.clientpastHomeRenvExp[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : clientPastHome?.fieldType === "Text" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{clientPastHome?.name}</p>
                                                    <div className="d-flex gap-2 w-50">

                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsSitution.clientpastHomeRenvExp[${index}].surveyResultOriginal`)}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                                : clientPastHome?.fieldType === "DD" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{clientPastHome?.name}</p>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select w-100"
                                                            // options={getdefaultLookups?.result?.
                                                            //     Lst_MethodOfInquiry?.map((option: any) => ({
                                                            //         label: option?.value,
                                                            //         value: option?.id
                                                            //     }))}
                                                            value={
                                                                formik.values?.lst_MethodOfInquiry?.id
                                                                    ? {
                                                                        value: formik.values?.lst_MethodOfInquiry?.id,
                                                                        label: formik.values?.lst_MethodOfInquiry?.value || '',
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                                                                formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                    : null
                                    }
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsSitution?.clientpastHomeRenvExp?.slice(4, 8).map((clientPastHome: any, index: any) => {
                                const actualIndex = index + 4; // Adjust index to reflect the actual position in the array
                                return (

                                    <Fragment key={actualIndex}>
                                        {clientPastHome?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center`}>
                                                <p className="mb-0">{clientPastHome?.name}</p>
                                                <div className="d-flex gap-5">

                                                    <label className="checkboxs positionCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={clientPastHome.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsSitution.clientpastHomeRenvExp[${actualIndex}].surveyResultOriginal`, clientPastHome.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : clientPastHome?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{clientPastHome?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">

                                                        <div className='d-flex gap-2 align-items-center'>                                                            <input
                                                            type="number"
                                                            min={0}
                                                            style={{ width: 50 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsSitution.clientpastHomeRenvExp[${actualIndex}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsSitution.clientpastHomeRenvExp[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                        />
                                                        </div>
                                                    </div>
                                                </div>
                                                : clientPastHome?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{clientPastHome?.name}</p>
                                                        <div className="d-flex gap-2 w-50">
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    className='w-100'
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsSitution.clientpastHomeRenvExp[${actualIndex}].surveyResultOriginal`)}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    : clientPastHome?.fieldType === "DD" ?
                                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                            <p className="mb-0 w-50">{clientPastHome?.name}</p>
                                                            <Select
                                                                styles={customStyles}
                                                                className="select w-100"
                                                                options={projectLookups?.result?.
                                                                    Lst_HouseType?.map((option: any) => ({
                                                                        label: option?.value,
                                                                        value: option?.id
                                                                    }))}
                                                                value={
                                                                    formik.values?.lst_MethodOfInquiry?.id
                                                                        ? {
                                                                            value: formik.values?.lst_MethodOfInquiry?.id,
                                                                            label: formik.values?.lst_MethodOfInquiry?.value || '',
                                                                        }
                                                                        : null
                                                                }
                                                                // isDisabled={isReadOnly}
                                                                onChange={(selectedOption: any) => {
                                                                    formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                                                                    formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                                                }}
                                                            />
                                                        </div>
                                                        : null
                                        }
                                    </Fragment>
                                );
                            })}

                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <h5 className='mb-2 mt-2'>Clients' Reason for Project</h5>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsSitution?.clientReasonForProject?.slice(0, 4).map((clientReasonForProject: any, index: any) => (
                                <Fragment key={index}>
                                    {clientReasonForProject?.fieldType === "Option" ?
                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                            <p className="mb-0">{clientReasonForProject?.name}</p>
                                            <div className="d-flex gap-5">

                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={clientReasonForProject.surveyResultOriginal === '1'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsSitution.clientReasonForProject[${index}].surveyResultOriginal`, clientReasonForProject.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                            </div>
                                        </div>
                                        : clientReasonForProject?.fieldType === "Numeric" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0 w-50">{clientReasonForProject?.name}</p>
                                                <div className="d-flex gap-3 w-50 justify-content-end">

                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            className='w-100'
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsSitution.clientReasonForProject[${index}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsSitution.clientReasonForProject[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : clientReasonForProject?.fieldType === "Text" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{clientReasonForProject?.name}</p>
                                                    <div className="d-flex gap-2 w-50">

                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsSitution.clientReasonForProject[${index}].surveyResultOriginal`)}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                                : clientReasonForProject?.fieldType === "DD" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{clientReasonForProject?.name}</p>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select w-100"
                                                            // options={getdefaultLookups?.result?.
                                                            //     Lst_MethodOfInquiry?.map((option: any) => ({
                                                            //         label: option?.value,
                                                            //         value: option?.id
                                                            //     }))}
                                                            value={
                                                                formik.values?.lst_MethodOfInquiry?.id
                                                                    ? {
                                                                        value: formik.values?.lst_MethodOfInquiry?.id,
                                                                        label: formik.values?.lst_MethodOfInquiry?.value || '',
                                                                    }
                                                                    : null
                                                            }
                                                            // isDisabled={isReadOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                                                                formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                    : null
                                    }
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsSitution?.clientReasonForProject?.slice(4, 8).map((clientReasonForProject: any, index: any) => {
                                const actualIndex = index + 4; // Adjust index to reflect the actual position in the array

                                return (
                                    <Fragment key={actualIndex}>
                                        {clientReasonForProject?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{clientReasonForProject?.name}</p>
                                                <div className="d-flex gap-5">

                                                    <label className="checkboxs positionCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={clientReasonForProject.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsSitution.clientReasonForProject[${actualIndex}].surveyResultOriginal`, clientReasonForProject.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : clientReasonForProject?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{clientReasonForProject?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">

                                                        <div className='d-flex gap-2 align-items-center'>                                                            <input
                                                            type="number"
                                                            min={0}
                                                            style={{ width: 50 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsSitution.clientReasonForProject[${actualIndex}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsSitution.clientReasonForProject[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                        />
                                                        </div>
                                                    </div>
                                                </div>
                                                : clientReasonForProject?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{clientReasonForProject?.name}</p>
                                                        <div className="d-flex gap-2 w-50">

                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    className='w-100'
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsSitution.clientReasonForProject[${actualIndex}].surveyResultOriginal`)}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    : clientReasonForProject?.fieldType === "DD" ?
                                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                            <p className="mb-0 w-50">{clientReasonForProject?.name}</p>
                                                            <Select
                                                                styles={customStyles}
                                                                className="select w-100"
                                                                options={projectLookups?.result?.
                                                                    Lst_HouseType?.map((option: any) => ({
                                                                        label: option?.value,
                                                                        value: option?.id
                                                                    }))}
                                                                value={
                                                                    formik.values?.lst_MethodOfInquiry?.id
                                                                        ? {
                                                                            value: formik.values?.lst_MethodOfInquiry?.id,
                                                                            label: formik.values?.lst_MethodOfInquiry?.value || '',
                                                                        }
                                                                        : null
                                                                }
                                                                // isDisabled={isReadOnly}
                                                                onChange={(selectedOption: any) => {
                                                                    formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                                                                    formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                                                }}
                                                            />
                                                        </div>
                                                        : null
                                        }
                                    </Fragment>
                                );
                            })}

                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <h5 className='mb-2 mt-2'>Project Background</h5>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsSitution?.projectBackground?.slice(0, 4).map((projectBackground: any, index: any) => (
                                <Fragment key={index}>
                                    {projectBackground?.fieldType === "Option" ?
                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                            <p className="mb-0">{projectBackground?.name}</p>
                                            <div className="d-flex gap-5">

                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={projectBackground.surveyResultOriginal === '1'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsSitution.projectBackground[${index}].surveyResultOriginal`, projectBackground.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                            </div>
                                        </div>
                                        : projectBackground?.fieldType === "Numeric" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0 w-50">{projectBackground?.name}</p>
                                                <div className="d-flex gap-3 w-50 justify-content-end">

                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            className='w-100'
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsSitution.projectBackground[${index}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsSitution.projectBackground[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : projectBackground?.fieldType === "Text" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{projectBackground?.name}</p>
                                                    <div className="d-flex gap-2 w-50">

                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsSitution.projectBackground[${index}].surveyResultOriginal`)}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                                : projectBackground?.fieldType === "DD" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{projectBackground?.name}</p>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select w-100"
                                                            // options={getdefaultLookups?.result?.
                                                            //     Lst_MethodOfInquiry?.map((option: any) => ({
                                                            //         label: option?.value,
                                                            //         value: option?.id
                                                            //     }))}
                                                            value={
                                                                formik.values?.lst_MethodOfInquiry?.id
                                                                    ? {
                                                                        value: formik.values?.lst_MethodOfInquiry?.id,
                                                                        label: formik.values?.lst_MethodOfInquiry?.value || '',
                                                                    }
                                                                    : null
                                                            }
                                                            // isDisabled={isReadOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                                                                formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                    : null
                                    }
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsSitution?.projectBackground?.slice(4, 8).map((projectBackground: any, index: any) => {
                                const actualIndex = index + 4; // Adjust index to reflect the actual position in the array

                                return (
                                    <Fragment key={actualIndex}>
                                        {projectBackground?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{projectBackground?.name}</p>
                                                <div className="d-flex gap-5">

                                                    <label className="checkboxs positionCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={projectBackground.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsSitution.projectBackground[${actualIndex}].surveyResultOriginal`, projectBackground.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : projectBackground?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{projectBackground?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">

                                                        <div className='d-flex gap-2 align-items-center'>                                                            <input
                                                            type="number"
                                                            min={0}
                                                            style={{ width: 50 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsSitution.projectBackground[${actualIndex}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsSitution.projectBackground[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                        />
                                                        </div>
                                                    </div>
                                                </div>
                                                : projectBackground?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{projectBackground?.name}</p>
                                                        <div className="d-flex gap-2 w-50">

                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <label> Original </label>
                                                                <input
                                                                    type="text"
                                                                    className='w-100'
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsSitution.projectBackground[${actualIndex}].surveyResultOriginal`)}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    : projectBackground?.fieldType === "DD" ?
                                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                            <p className="mb-0 w-50">{projectBackground?.name}</p>
                                                            <Select
                                                                styles={customStyles}
                                                                className="select w-100"
                                                                options={projectLookups?.result?.
                                                                    Lst_HouseType?.map((option: any) => ({
                                                                        label: option?.value,
                                                                        value: option?.id
                                                                    }))}
                                                                value={
                                                                    formik.values?.lst_MethodOfInquiry?.id
                                                                        ? {
                                                                            value: formik.values?.lst_MethodOfInquiry?.id,
                                                                            label: formik.values?.lst_MethodOfInquiry?.value || '',
                                                                        }
                                                                        : null
                                                                }
                                                                // isDisabled={isReadOnly}
                                                                onChange={(selectedOption: any) => {
                                                                    formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                                                                    formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                                                }}
                                                            />
                                                        </div>
                                                        : null
                                        }
                                    </Fragment>
                                );
                            })}

                        </div>
                    </div>
                </div>
            </div>

            {/* Scope  */}

            <>
                <div className='row'>
                    <h5 className='mb-2 mt-2'>Opportunity Scope</h5>
                    <div className="col-md-6">
                        <div className="card border-gray h-100">
                            <div className="card-body p-2">
                                <div className='d-flex gap-3 justify-content-end mb-2'>
                                    <p className='mb-0 fw-600'>
                                        Original
                                    </p>
                                </div>
                                {formik.values?.opportunityDetailsScopeDTO?.opportunityScop.slice(0, 4).map((opportunityScop: any, index: any) => (
                                    <Fragment key={index}>
                                        {opportunityScop?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{opportunityScop?.name}</p>
                                                <div className="d-flex gap-5">

                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={opportunityScop.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultOriginal`, opportunityScop.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : opportunityScop?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{opportunityScop?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">

                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                style={{ width: 50 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultOriginal`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                            />


                                                        </div>
                                                    </div>
                                                </div>
                                                : opportunityScop?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{opportunityScop?.name}</p>
                                                        <div className="d-flex gap-2 w-50">

                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    style={{ width: 50 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultOriginal`)}
                                                                />
                                                                <label>  </label>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    : null
                                        }
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card border-gray h-100">
                            <div className="card-body p-2">
                                <div className='d-flex gap-3 justify-content-end mb-2'>

                                    <p className='mb-0 fw-600'>
                                        Original
                                    </p>
                                </div>
                                {formik.values?.opportunityDetailsScopeDTO?.opportunityScop.slice(4, 8).map((opportunityScop: any, index: any) => {
                                    const actualIndex = index + 4; // Adjust index to reflect the actual position in the array

                                    return (
                                        <Fragment key={actualIndex}>
                                            {opportunityScop?.fieldType === "Option" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0">{opportunityScop?.name}</p>
                                                    <div className="d-flex gap-5">

                                                        <label className="checkboxs positionCheckBox">

                                                            <input
                                                                type="checkbox"
                                                                disabled={isReadOnly}
                                                                checked={opportunityScop.surveyResultOriginal === '1'}
                                                                onChange={() => {
                                                                    formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultOriginal`, opportunityScop.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                                }}
                                                            />
                                                            <span className="checkmarks mt-1" />
                                                        </label>
                                                    </div>
                                                </div>
                                                : opportunityScop?.fieldType === "Numeric" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{opportunityScop?.name}</p>
                                                        <div className="d-flex gap-3 w-50 justify-content-end">

                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    style={{ width: 50 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultOriginal`)}
                                                                    onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                                />


                                                            </div>
                                                        </div>
                                                    </div>
                                                    : opportunityScop?.fieldType === "Text" ?
                                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                            <p className="mb-0 w-50">{opportunityScop?.name}</p>
                                                            <div className="d-flex gap-2 w-50">

                                                                <div className='d-flex gap-2 align-items-center'>
                                                                    <input
                                                                        type="text"
                                                                        style={{ width: 50 }}
                                                                        disabled={isReadOnly}
                                                                        {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultOriginal`)}
                                                                    />
                                                                    <label>  </label>

                                                                </div>

                                                            </div>
                                                        </div>
                                                        : null
                                            }
                                        </Fragment>
                                    );
                                })}

                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <h5 className='mb-2 mt-2'>Addition Scope</h5>

                    <div className="col-md-6">
                        <div className="card border-gray h-100">
                            <div className="card-body p-2">
                                <div className='d-flex gap-3 justify-content-end mb-2'>

                                    <p className='mb-0 fw-600'>
                                        Original
                                    </p>
                                </div>
                                {formik.values?.opportunityDetailsScopeDTO?.additionScope.slice(0, 8).map((additionScope: any, index: any) => (
                                    <Fragment key={index}>
                                        {additionScope?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{additionScope?.name}</p>
                                                <div className="d-flex gap-5">

                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={additionScope.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultOriginal`, additionScope.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : additionScope?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{additionScope?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">

                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                style={{ width: 50 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultOriginal`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                            />


                                                        </div>
                                                    </div>
                                                </div>
                                                : additionScope?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{additionScope?.name}</p>
                                                        <div className="d-flex gap-2 w-50">

                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    style={{ width: 50 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultOriginal`)}
                                                                />
                                                                <label>  </label>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    : null
                                        }
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card border-gray h-100">
                            <div className="card-body p-2">
                                <div className='d-flex gap-3 justify-content-end mb-2'>

                                    <p className='mb-0 fw-600'>
                                        Original
                                    </p>
                                </div>
                                {formik.values?.opportunityDetailsScopeDTO?.additionScope.slice(8, 16).map((additionScope: any, index: any) => {
                                    const actualIndex = index + 8; // Adjust index to reflect the actual position in the array

                                    return (
                                        <Fragment key={actualIndex}>
                                            {additionScope?.fieldType === "Option" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0">{additionScope?.name}</p>
                                                    <div className="d-flex gap-5">

                                                        <label className="checkboxs positionCheckBox">

                                                            <input
                                                                type="checkbox"
                                                                disabled={isReadOnly}
                                                                checked={additionScope.surveyResultOriginal === '1'}
                                                                onChange={() => {
                                                                    formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultOriginal`, additionScope.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                                }}
                                                            />
                                                            <span className="checkmarks mt-1" />
                                                        </label>
                                                    </div>
                                                </div>
                                                : additionScope?.fieldType === "Numeric" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{additionScope?.name}</p>
                                                        <div className="d-flex gap-3 w-50 justify-content-end">

                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    style={{ width: 50 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultOriginal`)}
                                                                    onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                                />


                                                            </div>
                                                        </div>
                                                    </div>
                                                    : additionScope?.fieldType === "Text" ?
                                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                            <p className="mb-0 w-50">{additionScope?.name}</p>
                                                            <div className="d-flex gap-2 w-50">

                                                                <div className='d-flex gap-2 align-items-center'>
                                                                    <input
                                                                        type="text"
                                                                        style={{ width: 50 }}
                                                                        disabled={isReadOnly}
                                                                        {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultOriginal`)}
                                                                    />
                                                                    <label>  </label>

                                                                </div>

                                                            </div>
                                                        </div>
                                                        : null
                                            }
                                        </Fragment>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <h5 className='mb-2 mt-2'>Detailed Scope</h5>
                    <div className="col-md-6">
                        <div className="card border-gray h-100">
                            <div className="card-body p-2">
                                <div className='d-flex gap-3 justify-content-end mb-2'>

                                    <p className='mb-0 fw-600'>
                                        Original
                                    </p>
                                </div>
                                {formik.values?.opportunityDetailsScopeDTO?.detailedScope.slice(0, 11).map((detailedScope: any, index: any) => (
                                    <Fragment key={index}>
                                        {detailedScope?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{detailedScope?.name}</p>
                                                <div className="d-flex gap-5">

                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={detailedScope.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultOriginal`, detailedScope.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : detailedScope?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{detailedScope?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">

                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                style={{ width: 50 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultOriginal`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                            />


                                                        </div>
                                                    </div>
                                                </div>
                                                : detailedScope?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{detailedScope?.name}</p>
                                                        <div className="d-flex gap-2 w-50">

                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    className='w-100'
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultOriginal`)}
                                                                />
                                                                <label>  </label>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    : null
                                        }
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card border-gray h-100">
                            <div className="card-body p-2">
                                <div className='d-flex gap-3 justify-content-end mb-2'>

                                    <p className='mb-0 fw-600'>
                                        Original
                                    </p>
                                </div>
                                {formik.values?.opportunityDetailsScopeDTO?.detailedScope.slice(11, 22).map((detailedScope: any, index: any) => {
                                    const actualIndex = index + 11; // Adjust index to reflect the actual position in the array
                                    return (
                                        <Fragment key={actualIndex}>
                                            {detailedScope?.fieldType === "Option" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0">{detailedScope?.name}</p>
                                                    <div className="d-flex gap-5">

                                                        <label className="checkboxs positionCheckBox">
                                                            <input
                                                                type="checkbox"
                                                                disabled={isReadOnly}
                                                                checked={detailedScope.surveyResultOriginal === '1'}
                                                                onChange={() => {
                                                                    formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultOriginal`, detailedScope.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                                }}
                                                            />
                                                            <span className="checkmarks mt-1" />
                                                        </label>
                                                    </div>
                                                </div>
                                                : detailedScope?.fieldType === "Numeric" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{detailedScope?.name}</p>
                                                        <div className="d-flex gap-3 w-50 justify-content-end">

                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    style={{ width: 100 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultOriginal`)}
                                                                    onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : detailedScope?.fieldType === "Text" ?
                                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                            <p className="mb-0 w-50">{detailedScope?.name}</p>
                                                            <div className="d-flex gap-2 w-50">

                                                                <div className='d-flex gap-2 align-items-center'>
                                                                    <input
                                                                        type="text"
                                                                        style={{ width: 200 }}
                                                                        disabled={isReadOnly}
                                                                        {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultOriginal`)}
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>
                                                        : null
                                            }
                                        </Fragment>
                                    );
                                })}

                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <p className='mt-3 mb-2'><i>Created at 11/17/2023 by Ann Marie.01:00:22 PM Last modified at 11/17/2023 01:00:22 PM by Maxx Klein.</i></p>
                </div>
            </>

            {/* scope end */}
            <div className='col-md-12 d-flex justify-content-end '>
                <div className='mt-2 bg-red text-redd position-fixed bottom-0 px-2 rounded' style={{ right: "0px" }}><i>Created at 11/17/2023 by Ann Marie.01:00:22 PM Last modified at 11/17/2023 01:00:22 PM by Maxx Klein.</i></div>
            </div>
        </>
    )
}

export default OpportunityDetailsContactWizard